import {CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE} from 'Core/components/advanced/ConditionList/const';
import {get} from 'lodash';
import {getObjectKeyByValue} from 'Core/helpers/data';
import {CUSTOMER_FIELD} from 'Pages/apps/default/const';

/**
 * Map external condition types to internal values
 */
export const CONDITION_TYPE_MAP = {
	TEXT: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.TEXT,
	DECIMAL: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.NUMBER,
	INTEGER: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.INTEGER,
	YES_NO: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.BOOLEAN,
	SELECT: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.SELECT,
	ASYNC_SELECT: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.ASYNC_SELECT,
	DATE: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DATE,
	TIME: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.TIME,
	DATE_TIME: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DATETIME,
};

/**
 * Get input data from raw data
 * @param {string} rawData - Raw data received from IO.
 * @param {CustomerField} customerFiled - Condition field name (one of CUSTOMER_FIELDS). 
 * @return {ConditionListFieldItemDisplayType}
 */
export const input = (rawData, customerFiled) => {
	switch (customerFiled) {
		// Map a custom display type for birthday in order to use the proper input component
		case CUSTOMER_FIELD.BIRTHDAY: return CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DAY;
		// Regular condition type mapping
		default: return get(CONDITION_TYPE_MAP, rawData);
	}
};

/**
 * Get output data from input data
 * @param {ConditionListFieldItemDisplayType} inputData - Input data.
 * @return {string}
 */
export const output = inputData => {
	switch (inputData) {
		// Map a custom display type for DAY to TEXT since it is a text value
		// @explanation Special DAY type is used so that the proper input component will be used for the DAY values. 
		case CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DAY: return CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.TEXT;
		// Regular condition type mapping
		default: return getObjectKeyByValue(CONDITION_TYPE_MAP, inputData);
	}
};